import axios from "axios"
import {API_URL} from "../constants"

export async function getAssociates() {
   const res = await axios({
      method: "GET",
      url: `${API_URL}/admin/associates/`,
      withCredentials: true,
      headers: {
         "Content-Type": "application/json",
      },
   })
   return res.data
}

export async function postAssociate(associate: any) {
   await axios({
      method: "post",
      url: `${API_URL}/admin/associates/`,
      withCredentials: true,
      headers: {
         "Content-Type": "application/json",
      },
      data: associate,
   })
}

export async function editAssociate(id: string, associate: any) {
   await axios({
      method: "put",
      url: `${API_URL}/admin/associates/${id}`,
      withCredentials: true,
      headers: {
         "Content-Type": "application/json",
      },
      data: associate,
   })
}

export async function deleteAssociate(id:string)
{
   await axios({
      method:"delete",
      url: `${API_URL}/admin/associates/${id}`,
      headers : {},
      withCredentials: true,
   })
}
